"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PostPicture = function (_a) {
    var image = _a.image, children = _a.children;
    console.log("PostPicture: ", image);
    var url = image.url, alt = image.alt;
    return (react_1.default.createElement("picture", { className: "card__media" },
        react_1.default.createElement("img", { src: url, alt: alt }),
        children));
};
exports.default = PostPicture;
